import { z } from "zod";

export const schema = z.object({
  name: z
    .string()
    .min(1, "El nombre del rol es obligatorio")
    .max(125, "El nombre del rol no puede exceder los 125 caracteres")
    .nonempty()
    .refine((val) => {
      return val.trim().length > 0;
    }, "El nombre del rol no puede estar vacío"),
  description: z
    .string()
    .min(1, "La descripción del rol es obligatoria")
    .max(255, "La descripción del rol no puede exceder los 255 caracteres")
    .nonempty()
    .refine((val) => {
      return val.trim().length > 0;
    }, "La descripción del rol no puede estar vacía"),
});

export type NewRoleFormData = z.infer<typeof schema>;
